import type {Middleware} from '@reduxjs/toolkit';
import {authSlice} from '@goproblems/shared/state/auth';
import type {AuthState} from '@goproblems/shared/contracts/auth';
import {setLanguagePreference} from '@utils/language';
import {Storage} from '@utils/storage';

type AuthStoreState = {auth: AuthState};

export const authPersistence: Middleware<object, AuthStoreState> =
    store => next => action => {
        const result = next(action);

        if (authSlice.actions.setAuth.match(action)) {
            const auth = store.getState().auth;
            Storage.storeObjData('auth', auth);
            if (auth.user?.language) {
                setLanguagePreference(auth.user.language);
            }
        } else if (authSlice.actions.updatePreferences.match(action)) {
            const auth = store.getState().auth;
            if (auth.user) {
                Storage.storeObjData('auth', auth);
            }
        } else if (authSlice.actions.logout.match(action)) {
            Storage.removeData('auth');
            window.location.href = '/';
        }

        return result;
    };
